import { Col, DatePicker, Form, Input, Radio, Row } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { useTranslation } from "react-i18next";
import { DateFormat, STATUS_DOCUMENTATIONS } from "../../../../../constants/constants";
import { ControlFailureModel } from "../../../../../models/control-failure.model";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../atoms/icon";


const LearningActionSection = (props: FormSectionProps<ControlFailureModel>) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbLearningPoints")}
                        name="learning_points"
                        tooltip={{ title: t("ControlFailure.ttLearningPoints"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("learning_points", props.requiredFields)}
                    >
                        <TextArea rows={5} maxLength={150} placeholder={t("Global.plTextArea")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbActionPointsDescription")}
                        name="action_points_description"
                        tooltip={{ title: t("ControlFailure.ttActionPointsDescription"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("action_points_description", props.requiredFields)}
                    >
                        <Input placeholder={t("Global.plInputComment")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbTargetCompletionDate")}
                        name="target_completion_date_picker"
                        tooltip={{ title: t("ControlFailure.ttTargetCompletionDate"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("target_completion_date", props.requiredFields)}
                    >
                        <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbActualCompletionDate")}
                        name="actual_completion_date_picker"
                        tooltip={{ title: t("ControlFailure.ttActualCompletionDate"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("actual_completion_date", props.requiredFields)}
                    >
                        <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbSupervisorResponsible")}
                        name="supervisor_responsible"
                        tooltip={{ title: t("ControlFailure.lbSupervisorResponsible"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("supervisor_responsible", props.requiredFields)}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]} className="has-check-box">
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbStatusDocumentation")}
                        name="status"
                        tooltip={{ title: t("ControlFailure.ttStatusDocumentation"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("status", props.requiredFields)}
                    >
                        <Radio.Group>
                            {STATUS_DOCUMENTATIONS.map((item, index) => (
                                <Radio key={index} value={item.value}>
                                    {item.name}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        name="additional_documentation"
                        valuePropName="checked"
                        rules={VALIDATION_UTIL.getRulesValidationField("additional_documentation", props.requiredFields)}
                    >
                        <Checkbox >{t("ControlFailure.learningPoinCheck")}</Checkbox>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbAdditionalDocumentationNotes")}
                        name="location_of_documentation"
                        tooltip={{ title: t("ControlFailure.ttAdditionalDocumentationNotes"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("location_of_documentation", props.requiredFields)}
                    >
                        <TextArea rows={5} maxLength={150} placeholder={t("Global.plTextArea")} />
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default LearningActionSection;